export default __webpack_public_path__ + "static/media/cards-stack-offset-dark-icon.5d5c5aa9.svg";